import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import application_properties from '../../applicationProperties';
import { firestoreEmulatorHost, functionsEmulatorUrl, isLocalDemo } from '../../helpers/localDemo';

// Firebase Initialization
firebase.initializeApp(application_properties.firebaseConfig);

// LOCAL DEMO MODE ONLY:
// When REACT_APP_DEMO_LOCAL is "true" (set in .env, never in deployed builds), the
// app talks to the local emulators instead of the real project.
if (isLocalDemo) {
  firebase.firestore().settings({ host: firestoreEmulatorHost, ssl: false });
  firebase.app().functions(application_properties.region).useFunctionsEmulator(functionsEmulatorUrl);
}
